<template>
  <div class="tab-pane active" >
    <div class="row" >
      <div class="col-sm-12">
        <h4 class="info-text ">
          Please tell us a bit more about you 
        </h4>
        <p>Our webinars are designed to help you with your property purchase plans. We are here to help!</p>
      </div>
      <div class="col-sm-6" >
        <div class="form-group">
          <label class="form-label required">Title</label>
          <select
            name="title"
            class="form-control custom-select"
            required
            v-model="title"
            :class="{ error: errors.has('step2.title') }"
            data-vv-scope="step2"
            v-validate="'required'"
          >
            <option value="">Select...</option>
            <option value="46">Mr.</option>
            <option value="47">Mrs.</option>
            <option value="51">Ms</option>
            <option value="253">Miss.</option>
            <option value="48">Dr.</option>
            <option value="49">Sir</option>
            <option value="122">Professor</option>
            <option value="441">Lady</option>
            <option value="50">Lord</option>
            <option value="506">Other</option>
          </select>
          <!-- <label class="error" v-show="errors.has('step2.firstname')">This field is required.</label> -->
        </div>
      </div>
      <div class="col-sm-12 ">
        <div class="form-group">
          <label class="form-label required">First Name</label>
          <input
            name="firstname"
            type="text"
            class="form-control"
            placeholder="First Name"
            v-model.trim="firstName"
            :class="{ error: errors.has('step2.firstname') }"
            data-vv-scope="step2"
            v-validate="'required'"
          />
          <!-- <label class="error" v-show="errors.has('step2.firstname')">This field is required.</label> -->
        </div>
      </div>
      <div class="col-sm-12 ">
        <div class="form-group">
          <label class="form-label required">Last Name</label>
          <input
            name="lastname"
            type="text"
            class="form-control"
            :class="{ error: errors.has('step2.lastname') }"
            placeholder="Last Name"
            v-model.trim="lastName"
            data-vv-scope="step2"
            v-validate="'required'"
          />
        </div>
      </div>
       <div class="col-sm-12 ">
        <div class="form-group">
          <label class="required">Mobile</label>
          &nbsp;<label class="small">(You will receive confirmation of your event registration via text message to the number provided)</label>
          <div class="row">
            <div class="col-sm-4 ">
              <vue-select
                class="vue-select"
                name="mobilePrefix"
                placeholder="Prefix"
                :options="countryCodes"
                :reduce="
                  code => code.TwoCharCode + '|' + code.CountryTelCode + '|'
                "
                label="CountryTelCode"
                v-model="mobilePrefix"
                autocomplete="none"
                 :class="{ error: errors.has('step2.mobilePrefix') }"
                  data-vv-scope="step2"
                 v-validate="'required'"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CountryTelCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  <span
                    class="flag-icon flag-icon-squared"
                    :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
                  ></span
                  >&nbsp;
                  {{ option.CountryTelCode }}
                </template>
              </vue-select>
            </div>
            <div class="col-sm-8 mt-xs-10">
              <input
                type="tel"
                name="mobile"
                class="form-control"
                placeholder="Mobile"
                v-model.trim="mobile"
                 :class="{ error: errors.has('step2.mobile') }"
                data-vv-scope="step2"
                v-validate="'required'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Email</label>
          <input
            name="email"
            type="email"
            class="form-control"
            :class="{ error: errors.has('step2.email') }"
            placeholder="Email Address"
            v-model.trim="email"
            data-vv-scope="step2"
            v-validate="'required|email'"
          />
        </div>
      </div>
       <div class="col-sm-12 mt-2">
         <privacy-policy />
      </div>
    </div>
   
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "flag-icon-css/css/flag-icon.min.css";
import { mapFields } from 'vuex-map-fields';
import { Common } from "@/helper/common";
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';

export default {
  name: "About",
  computed:{
     ...mapFields([
      'form.title',
      'form.firstName',
      'form.lastName',
      "form.mobilePrefix",
      "form.mobile",
      'form.email',
      "form.virtualEventOptIn"
    ]),
     ...mapGetters({
      countryCodes: "getCountryCodes"
    })
  },
  components:{
    "vue-select": VueSelect,
     "privacy-policy": PrivacyPolicy,
  },
  data() {
    return {
      error: null
    };
  },
  created(){
    if (this.$route.params.cleanForm )
    {
      //clear form
      this.title="";
      this.firstName="";
      this.lastName="";
      this.email="";
      this.$route.params.cleanForm=null;
      this.virtualEventOptIn=false;
    }
    if (Common.getCookie("email") != null) this.email = Common.getCookie("email");
if (Common.getCookie("firstname") != null)
  this.firstName = Common.getCookie("firstname");
if (Common.getCookie("lastname") != null)
  this.lastName = Common.getCookie("lastname");
if (Common.getCookie("title") != null)
  this.title = Common.getCookie("title");
if (Common.getCookie("mobilePrefix") != null)
  this.mobilePrefix = Common.getCookie("mobilePrefix");
if (Common.getCookie("mobile") != null)
  this.mobile = Common.getCookie("mobile");
  }
};
</script>
